import { FactoryProvider, InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('window');

/**
 * using the global window object is not conducive to unit testing.
 * Therefore, we will inject it so that we can provide alternate mock instances
 * as necessary
 */
const windowProvider: FactoryProvider = {
    provide: WINDOW,
    useFactory: () => window,
};

export const WINDOW_PROVIDERS = [windowProvider];
